import createApp from 'createApp'
const lpHeaderSmall = () => import('Components/Landing/LandingPage/lpHeaderSmall.vue')
const lpJumbotron = () => import('Components/Landing/LandingPage/lpJumbotron.vue')
const lpNumbers = () => import('Components/Landing/LandingPage/lpNumbers.vue')
const lpHowitworks = () => import('Components/Landing/LandingPage/lpHowItWorks.vue')
const lpClients = () => import('Components/Landing/LandingPage/lpClients.vue')
const lpMission = () => import('Components/Landing/LandingPage/lpMission.vue')
const lpCategories = () => import('Components/Landing/LandingPage/lpCategories.vue')
const lpTestmonials = () => import('Components/Landing/LandingPage/lpTestmonials.vue')

const initialState = () => ({})

createApp({
  components: {
    lpHeaderSmall,
    lpJumbotron,
    lpNumbers,
    lpHowitworks,
    lpClients,
    lpMission,
    lpCategories,
    lpTestmonials,
  },

  data() {
    return initialState()
  },
})
